<!-- eslint-disable -->
<template lang="pug">
    .row.payment-service-preview
        .col-xs-10.col-sm-11.payment-service-preview__column
            .payment-service-preview__name
                router-link.payment-service-preview__link.payment-service-preview__link_large(
                    :to="{\
                            name: 'payment-services:edit',\
                            params: {id: profile.id, type: 'payment-services', copy: profile}\
                    }"
                )
                    .payment-service-preview__avatar
                        svg-icon.payment-service-preview__icon(name="money", size="x-large")
                    .preview__text.preview__text_large
                        | {{ profile.name }}
        .col-xs-2.col-sm-1.end-xs.payment-service-preview__column
            dropdown(:icon="false" :is-last="isLast" without-move)
                template(slot="link")
                    svg-icon.payment-service-preview__icon.payment-service-preview__icon_blue(name="select", :size="selectorSize")
                ul.dropdown__links
                    li.dropdown__link
                        router-link.payment-service-preview__link(
                            :to="{\
                                    name: 'payment-services:edit', \
                                    params: {id: profile.id, type: 'payment-services', copy: profile}\
                            }"
                        )
                            | {{ $i18n.t('list.list_common_actionsEdit') }}
                    li.dropdown__link
                        a(
                            href="javascript://"
                            @click="displayConfirmDeleteModal = true"
                        )
                            | {{ $i18n.t('list.list_common_actionsDelete') }}
        confirm-delete-modal(
            v-if="displayConfirmDeleteModal"
            @close="displayConfirmDeleteModal = false"
            @delete="$emit('delete', profile.id)"
        )
            | {{ " " + $i18n.t('list.list_paymentServices_deletePaymentServiceModal') }} "{{ profile.name }}"
</template>

<script>
    /*eslint-disable*/
    import Dropdown from '../../../../elements/Dropdown.vue';
    const ConfirmDeleteModal = () => import('../../../../modals/ConfirmDeleteModal.vue');
    import { mapState } from 'vuex';

    export default {
        props: {
            profile: {
                type: Object,
                default: null,
            },
            isLast: Boolean,
        },
        data() {
            return {
                displayConfirmDeleteModal: false
            };
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            selectorSize () {
                const windowWidth = window.innerWidth;
                return windowWidth >= 1200 ? 'xx-large' : 'x-large';
            }

        },
        components: {
            Dropdown,
            ConfirmDeleteModal
        }
    }
</script>

<style lang="scss" scoped>
    .payment-service-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
    }

    .payment-service-preview__column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
    }

    .payment-service-preview__name {
        display: flex;
        align-items: center;
    }

    .payment-service-preview__avatar {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: $border-radius-circle;
        background-color: #F3F8EF;
    }

    .payment-service-preview__icon {
        color: $hsl-color-green-58;
    }

    .payment-service-preview__icon_blue {
        color: $hsl-color-blue-56;
    }

    .preview__text {
        margin-left: 8px;
    }

    .preview__text_large {
        margin-left: 16px;
    }

    .payment-service-preview__link {
        display: flex;
        align-items: center;
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .payment-service-preview__link_large {
        font-size: 16px;
        line-height: 20px;
        @include media($lg) {
            font-size: 18px;
        }
    }

    .dropdown__links {
        padding: 7px 14px;
        text-align: left;
        font-size: 16px;
        line-height: 26px;
    }

    .dropdown__link {
        padding-bottom: 7px;
        a {
            color: $hsl-color-blue-56;
            text-decoration: underline;
            &:hover {
                color: $hsl-color-blue-56;
                text-decoration: none;
            }
        }
    }
</style>
